import { render, staticRenderFns } from "./getlotv.vue?vue&type=template&id=e4ede256&scoped=true&"
import script from "./getlotv.vue?vue&type=script&lang=js&"
export * from "./getlotv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ede256",
  null
  
)

export default component.exports